import { Box, Typography } from "@mui/material";
import PercentageChange from "../../../../components/dashboard/PercentageChange";

interface IStatCardWidgetProps {
  text: string;
  percentageChange: number | undefined;
  isPositiveValueBeneficial: boolean;
}

const StatCard = ({ text, percentageChange, isPositiveValueBeneficial }: IStatCardWidgetProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>
        {text}
      </Typography>
      <PercentageChange value={percentageChange} isPositiveValueBeneficial={isPositiveValueBeneficial} />
    </Box>
  );
};

export default StatCard;